import { render, staticRenderFns } from "./memorial.vue?vue&type=template&id=d7be8190&scoped=true&"
import script from "./memorial.vue?vue&type=script&lang=js&"
export * from "./memorial.vue?vue&type=script&lang=js&"
import style0 from "./memorial.vue?vue&type=style&index=0&id=d7be8190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7be8190",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VImg})
